<template>
    <div class="login-body">
        <el-form :model="loginForm" :rules="rules2" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
            <h3 class="title"><img src="../static/image/logo.png" class="company_logo" />比创达EMC系统登录</h3>
            <el-form-item prop="account">
                <el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="账号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-row>
                <el-col :span="12">
                  <el-input v-model="loginForm.captcha" placeholder="请输入验证码"></el-input>
                </el-col>
                <el-col :span="12" class="captcha-image" >
                  <img :src="captchaUrl" alt="验证码" @click="refreshCaptcha" style="margin-left: 30px;" />
                </el-col>
              </el-row>
            </el-form-item>
<!--            <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
            <el-form-item style="width:100%;">
                <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
            </el-form-item>
            <el-form-item style="width:100%;">
                <el-button type="text" style="float: right" @click.native.prevent="heandleToRegister" >去注册</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {requestLogin} from '../api/api';
import NProgress from 'nprogress'
import {onMounted, ref } from "vue";
import {useRoute,useRouter} from "vue-router/composables.mjs";
import {Message} from 'element-ui';
// import {useRouter} from "vue-router/composables";
// import {useRoute, useRouter} from "vue-router/composables";

export default {
  setup() {
    const route = useRoute()
    const ssoTk = ref('')

    let router = useRouter();

    onMounted(() => {
      let token=localStorage.getItem("token");

      ssoTk.value = route.query['ssotk']
      token= ssoTk.value;
      let path= route.query['route']
      const hasIsDynamicTableParam = 'isDynamicTable' in route.query;
      if (token && !path) {
          router.push({path: "/member/index" });
      }
      if(hasIsDynamicTableParam){
        let isDynamicTable= route.query['isDynamicTable']
        localStorage.setItem('isDynamicTable',isDynamicTable)
      }

      if (token) {
        localStorage.setItem('token',token)
        router.push({path: "/"+path })
      }

    })

    return {
      ssoTk
    }
  },
    data() {
        return {
            logining: false,
            loginForm: {
                account: '',
                password: ''
            },
            rules2: {
                account: [
                    {required: true, message: '请输入账号', trigger: 'blur'},
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                ],
                captcha: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            },
            checked: true,
            captchaUrl: '',
        };
    },
    created() {
        this.refreshCaptcha();
    },
    methods: {
        handleReset2() {
            this.$refs.loginForm.resetFields();
        },
      handleSsoOk() {
        this.$router.push({path: '/staHome'});
      },
      refreshCaptcha() {
          let currentTimestamp = new Date().getTime();
          let threeDaysLaterTimestamp = currentTimestamp + (3 * 24 * 60 * 60 * 1000);
          this.$api.get(`/sys/randomImage/1629428467008?_t=${threeDaysLaterTimestamp}`).then(res => {
              if (res.data.success) {
                  this.captchaUrl = res.data.result;
                  delete this.loginForm.captcha;
              }
          })
      },
      handleSubmit2(ev) {
            console.log("登录设置",ev)

            var _this = this;
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.logining = true;
                    var loginParams = {
                        checkKey: '1629428467008',
                        username: this.loginForm.account, 
                        password: this.loginForm.password,
                        captcha: this.loginForm.captcha
                    };
                    this.$api.post('/sys/login', loginParams).then(res => {
                        if (res.data.status === 412) {
                            this.$notify.error(res.data.message);
                            this.refreshCaptcha()
                            this.logining = false;
                        } else if (res.data.status === 500) {
                            loginParams.loginName = loginParams.username;
                            this.$api.post('/emc-member-auth/pwd-login', loginParams).then(res => {
                                this.logining = false;
                                let data= res.data;
                                if(data.code==200){
                                    this.loginSuccess(data)
                                } else {
                                  Message.info(JSON.stringify(res.data.message));
                                }
                            })
                        } else {
                            this.loginSuccess(res.data)
                        }
                    }).catch(e => {
                        console.log(e)
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        loginSuccess(data) {
            this.logining = false;
            let token= data.result.token;
            localStorage.setItem('isDynamicTable', 1)
            localStorage.setItem('token', token)
            localStorage.setItem('userInfo', JSON.stringify(data.result.userInfo || data.result.memberInfo))
            this.$router.push({path: '/member/index'});
        },
        heandleToRegister(){
          this.$router.push({path: '/register'})
        }
    }
}

</script>
<style lang="css" scoped>
    .login-body {
        width: 100%;
        height: 100%;
        display: flex;
        background-image: url("../static/image/login-image.png");
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>
<style lang="scss" scoped>
.login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: auto;
    //margin-top: 10px;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    //box-shadow: 0 0 25px #cac6c6;
    //opacity: 0.8;

    .title {
        margin: 0px auto 40px auto;
        text-align: center;
        color: #505458;
    }

    .remember {
        margin: 0px 0px 35px 0px;
    }
}
.company_logo {
    height: 18px;
    width: 60px;
    margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/Login.vue